import { useDispatch, useSelector } from "react-redux";
import { setCliente, clearCliente, updateCliente } from "../store/cliente/clienteSlice";

export const useClienteStore = () => {
  const cuit = useSelector(state => state.cliente.cuit);
  const razonSocial = useSelector(state => state.cliente.razonSocial);
  const codigoPostal = useSelector(state => state.cliente.codigoPostal);
  const calle = useSelector(state => state.cliente.calle);
  const numero = useSelector(state => state.cliente.numero);
  const localidad = useSelector(state => state.cliente.localidad);
  const catIva = useSelector(state => state.cliente.catIva);
  const condVenta = useSelector(state => state.cliente.condVenta);

  const dispatch = useDispatch();

  // Métodos para interactuar con el estado
  const setNewCliente = cliente => {
    dispatch(setCliente(cliente));
  };

  const clearClienteState = () => {
    dispatch(clearCliente());
  };

  const updateClienteField = (key, value) => {
    dispatch(updateCliente({ key, value }));
  };

  return {
    // Propiedades del estado
    cuit,
    razonSocial,
    codigoPostal,
    calle,
    numero,
    localidad,
    catIva,
    condVenta,

    // Métodos para actualizar el estado
    setNewCliente,
    clearClienteState,
    updateClienteField,
  };
};
